import Vue from 'vue/dist/vue.esm.js';
import {formatPrice} from '../utility/formatPrice'
import {parseCartResponse, serializeCartForEvent} from '../utility/parseCartResponse'

Vue.component('cart-widget', {
    template: `#cart-widget`,
    delimiters: ['[[', ']]'],
    props: {
        initialCart: {
            required: false,
            type: [String, Object],
            default: () => ({
                quantity: 0,
                total: 0,
                promocode: null,
                rows: [],
                id: null,
                hash: null,
                totalPriceAfterDiscount: 0,
                originalTotal: 0,
                discount: 0,
                loyaltyProgramDiscount: 0,
                totalPromocodeDiscount: 0,
                haveFreeDeliveryDiscount: false
            })
        },
        locale: {
            required: true,
            type: String,
        },
        currency: {
            required: true,
            type: String,
        },
        removeCartRowUrl: {
            required: true,
            type: String,
        },
        free_delivery_price: {
            required: true
        },
        specialProductsUrl: {
            type: String
        },
        incrementUrl: {
            required: true,
            type: String,
        },
        decrementUrl: {
            required: true,
            type: String,
        },
        promocodeUrl: {
            required: true,
            type: String,
        },
        removePromocodeUrl: {
            required: true,
            type: String,
        },
        mobile: {
            required: false,
            type: String,
        },
        exchangeRate: {
            required: true,
            type: String,
        },
        exchangeRateMode: {
            required: true,
            type: String,
        },
        convertMode: {
            required: true,
            type: String,
        },
        showEurFirst: {
            required: false,
            type: String,
            default: '0'
        }
    },

    mounted() {
        EventManager.listen('cart-widget-open', this.cartWidgetOpen);
        EventManager.listen('item-added', this.itemAdded);
        EventManager.listen('item-removed', this.itemRemoved);
        EventManager.listen('item-added', this.cartUpdatedData);
        EventManager.listen('cart-updated', this.cartUpdatedData);
        EventManager.listen('item-removed', this.cartUpdatedData);

        EventManager.listen('decrement-event', this.decrementQuantity);
        EventManager.listen('increment-event', this.incrementRowQuantity);
        EventManager.listen('remove-row-event', (params) => {
            this.removeRow(params.id, params.removeItemUrl);
        });
        this.setSpecialProductsHtml();
        this.setDidYouForgetSomethingHtml();
    },

    data() {
        const defaultCart = {
            quantity: 0,
            total: 0,
            promocode: null,
            rows: [],
            id: null,
            hash: null,
            totalPriceAfterDiscount: 0,
            originalTotal: 0,
            discount: 0,
            loyaltyProgramDiscount: 0,
            totalPromocodeDiscount: 0,
            haveFreeDeliveryDiscount: false
        };
        
        // Handle both JSON string and object formats
        let cart = defaultCart;
        if (this.initialCart) {
            if (typeof this.initialCart === 'string') {
                try {
                    cart = JSON.parse(this.initialCart) || defaultCart;
                } catch (e) {
                    console.warn('Failed to parse cart JSON:', e);
                    cart = defaultCart;
                }
            } else if (typeof this.initialCart === 'object' && this.initialCart !== null) {
                cart = this.initialCart;
            }
        }
        return {
            cart: cart,
            showSuccessMessage: false,
            showSuccessRemoveMessage: false,
            specialProductsHtml: "",
            didYouForgetSomethingHtml: "",
            showPromocode: false,
            hasPromocode: !!(cart && cart.promocode),
            promocode: (cart && cart.promocode) || null,
            promocodeText: null,
            promocodeError: null,
            quantityAlert: {
                visible: false,
                productName: '',
            },
            isMobile: this.mobile === "1",
            specialProductsGtmData: false,
            didYouForgetSomethingGtmDatya: false,
            showCartItems: false,
        }
    },

    methods: {
        formatDualPrice(price) {
            return formatPrice(price, this.exchangeRate, this.exchangeRateMode, this.convertMode, true, this.showEurFirst);
        },
        cartUpdatedData(data) {
            const cart = parseCartResponse(data);
            if (!cart) {
                return;
            }

            this.cart = cart;

            this.hasPromocode = !!(this.cart && this.cart.promocode);
            this.promocode = (this.cart && this.cart.promocode) || null;

            if (this.cart && this.cart.promocode) {
                this.promocodeText = this.cart.promocode.code;
            } else {
                this.promocodeText = null;
            }
            EventManager.fire('update-quantity', this.cart);
        },
        addVariantQuantity(row) {
            let _self = this;
            let url = _self.incrementUrl;
            if (row.isAddedAsSpecialProductFromCart) {
                url += "?source=cart";
            }
            $.ajax({
                data: {id: row.variantId},
                url: url,
                method: 'POST',
                success: function (result) {
                    if (result.success !== false) {
                        _self.quantityAlert.visible = false;
                        EventManager.fire('item-added', result.cart);
                        EventManager.fire('cart-updated', result.cart);

                        let event = {
                            event: 'add_to_cart',
                            eventData: result.variant,
                            unique_event_id: result.unique_event_id,
                            action: 'CartPage',
                            cart:  result.cart
                        }

                        EventManager.fire('gtm-event', event);

                    } else {
                        _self.quantityAlert.visible = true;
                        _self.quantityAlert.productName = row.name;
                    }
                },
            });
        },
        decrementVariantQuantity(row) {
            let _self = this;
            let url = _self.decrementUrl;
            if (row.isAddedAsSpecialProductFromCart) {
                url += "?source=cart";
            }
            $.ajax({
                data: {id: row.id},
                url: url,
                method: 'POST',
                success: function (result) {
                    _self.quantityAlert.visible = false;
                    EventManager.fire('item-removed', result.cart);
                    let event = {
                        event: 'remove_from_cart',
                        eventData: result.variant,
                        action: 'CartPage',
                    }
                    EventManager.fire('gtm-event', event);
                },
            });
        },

        cartWidgetOpen() {

            if(this.specialProductsGtmData){
                EventManager.fire('gtm-event', this.specialProductsGtmData);
            }
            if(this.didYouForgetSomethingGtmDatya){
                EventManager.fire('gtm-event', this.didYouForgetSomethingGtmDatya);
            }
        },
        incrementRowQuantity(row) {
            if (row.quantity > 99) {
                return;
            }
            this.addVariantQuantity(row);

        },

        decrementQuantity(row) {
            if (row.quantity === 1) {
                return;
            }
            this.decrementVariantQuantity(row);
        },

        itemAdded(data) {
            const cart = parseCartResponse(data);
            if (!cart) {
                return;
            }

            this.cart = cart;

            this.showAddedToCartFlash();

            this.showSuccessMessage = true;
            this.showSuccessRemoveMessage = false;
        },

        itemRemoved(data) {
            const cart = parseCartResponse(data);
            if (!cart) {
                return;
            }

            this.cart = cart;
            this.showSuccessMessage = false;
            this.showSuccessRemoveMessage = true;
        },

        cartUpdated(data) {
            const cart = parseCartResponse(data);
            if (!cart) {
                return;
            }

            this.cart = cart;
            this.showAddedToCartFlash()
        },

        removeRow(rowId, removeItemUrl) {
            this.buildAjax(rowId, removeItemUrl);
        },

        formattedPrice(price) {
            return new Intl.NumberFormat(this.locale, {style: 'currency', currency: this.currency}).format(price);
        },

        buildAjax(rowId, url) {
            let _self = this
            $.ajax({
                data: {id: rowId},
                url: url,
                method: 'POST',
                success: function (result) {
                    _self.successAjax(result)
                },
            });
        },

        successAjax(result) {
            if (result.success === false) {
                return;
            }

            EventManager.fire('item-removed', result.cart);

            let event = {
                event: 'remove_from_cart',
                eventData: result.variant,
                action: 'CartWidget',
            }
            EventManager.fire('gtm-event', event);
            EventManager.fire(`remove-row-${result.variant.id}`, result.variant.id);
        },

        concatenateAttributeValues(attributes) {
            let str = '';
            for (let [index, attribute] of attributes.entries()) {
                if (index !== 0) {
                    str += ', '
                }
                if (attribute.showUnit) {
                    str += attribute.unit + ' x '
                }
                str += ' ' + attribute.value;

            }
            return str;
        },

        applyPromocode() {
            let _self = this;
            $.ajax({
                data: {code: _self.promocodeText},
                url: _self.promocodeUrl,
                method: 'POST',
                success: function (result) {
                    if (result.success === false) {
                        _self.promocodeError = result.error;
                        return;
                    }

                    const cart = parseCartResponse(result);
                    if (!cart) {
                        return;
                    }

                    _self.promocodeError = null;
                    _self.cart = cart;
                    _self.hasPromocode = !!cart.promocode;
                    _self.promocode = cart.promocode || null;
                    EventManager.fire('item-added', serializeCartForEvent(cart));
                    EventManager.fire('cart-updated', serializeCartForEvent(cart));
                },
            });
        },

        removePromocode() {
            let _self = this;
            $.ajax({
                url: _self.removePromocodeUrl,
                method: 'POST',
                success: function (result) {
                    const cart = parseCartResponse(result);
                    if (!cart) {
                        return;
                    }

                    _self.cart = cart;
                    _self.hasPromocode = !!cart.promocode;
                    _self.promocode = cart.promocode || null;
                    EventManager.fire('item-added', serializeCartForEvent(cart));
                    EventManager.fire('cart-updated', serializeCartForEvent(cart));
                },
            });
        },


        buildAjaxCustom(data, url, method = 'POST') {
            return $.ajax({
                data: data,
                url: url,
                method: method,
            });
        },

        setSpecialProductsHtml() {
            let specialOffersCatId = 2;

            this.buildAjaxCustom({'catId': specialOffersCatId}, this.specialProductsUrl)
                .then((result) => {
                    if (result.productsHtml) {
                        this.specialProductsHtml = result.productsHtml;
                        if(result.gtmData){
                            this.specialProductsGtmData = result.gtmData;
                        }
                    }
                });
        },

        setDidYouForgetSomethingHtml() {
            let specialOffersCatId = 3;

            this.buildAjaxCustom({'catId': specialOffersCatId}, this.specialProductsUrl)
                .then((result) => {
                    if (result.productsHtml) {
                        this.didYouForgetSomethingHtml = result.productsHtml;
                        if(result.gtmData){
                            this.didYouForgetSomethingGtmDatya = result.gtmData;
                        }
                    }
                });
        },
        showAddedToCartFlash(){
                $('body').addClass('added-to-cart')
                setTimeout(() => {
                    $('body').removeClass('added-to-cart')
                }, 2500);
        },
        toggleShowCartItems() {
            this.showCartItems = !this.showCartItems;
        }
    },

    computed: {
        total() {
            return this.formattedPrice(this.cart?.total || 0)
        },
        priceLeftForFreeDelivery() {
            if (this.cart?.promocode?.freeDelivery) {
                return 0;
            }
            return this.free_delivery_price - (this.cart?.total || 0)
        },
        priceLeftForFreeDeliveryFormatted() {
            return this.formatDualPrice(this.free_delivery_price - (this.cart?.total || 0))
        },
        priceLeftForFreeDeliveryPercentage() {
            if (this.cart?.haveFreeDeliveryDiscount) {
                return "width:" + 100 + "%";
            }
            let priceLeft = this.free_delivery_price - (this.cart?.total || 0);
            let percentage = (100 - ((100 * priceLeft) / this.free_delivery_price).toFixed(0));
            percentage = percentage > 100 ? 100 : percentage;
            return "width:" + percentage + "%"
        },
        formattedPromocodeDiscount() {
            return '-' + this.formattedPrice(this.cart?.totalPromocodeDiscount || 0);
        },
    }
});
